import { PropertyType as SrsPropertyType, PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { values } from '../endpoints';

import { TableWrapper } from './wrapper';
import { TableWidgetKnobs } from './knobs';

export const config = {
	key: 'TABLE',
	label: 'Table',
	icon: 'th',
	wrapper: TableWrapper,
	endpoint: async (...args) => {
		const columns = args[2].columns;
		const data = await values(...args);
		return { data, columns };
	},
	Knobs: TableWidgetKnobs,
	flags: [SrsPropertyFlag.Document],
	types: [SrsPropertyType.Numeric, SrsPropertyType.String, SrsPropertyType.Temporal],
	createDefaultOptions: (filteredProperties) => {
		return {
			options: {
				columns: filteredProperties.map((x) => x.name),
				parameters: {
					MaxValues: 100,
					descending: false,
					sortProperty: filteredProperties[0]?.name,
				},
			},
		};
	},
	isValid: () => {
		// any data can be shown in the table?
		return true;
	},
};
